import ajax, { isHttpError, isNetworkError } from "../../authenticationSafeAjax";
import { addContactGroup, updateContactGroup } from "./contactsActions";

function toContactGroupAddedEvent(contactGroup) {
    return {
        name: contactGroup.name,
        contacts: contactGroup.contacts.map(contact => contact.emailAddress)
    };
}

function request(method, url, body, callback) {
    const request = {
        method,
        body,
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        url,
        timeout: 10000
    };

    ajax(request, (statusCode, responseBody) => {
        let response;

        if (isHttpError(statusCode)) {
            response = { errors: ["Unable to create contact group due to an unexpected error."] };
        } else if (isNetworkError(statusCode)) {
            response = { errors: ["Unable to create contact group due to connectivity issues. Please try again."] };
        } else {
            response = responseBody ? JSON.parse(responseBody) : { errors: [] };
        }

        callback(response);
    });
}

function hasErrors(response) {
    return response.errors && response.errors.length !== 0;
}

export function createContactGroup(contactGroup, dispatch) {
    return new Promise((resolve, reject) => {
        request("POST", "/recorder/api/contact-groups", JSON.stringify(toContactGroupAddedEvent(contactGroup)), response => {
            if (hasErrors(response)) {
                reject({ _error: response.errors });
            } else {
                dispatch(addContactGroup(Object.assign({}, contactGroup, { id: response.id })));
                resolve();
            }

        });
    });
}

export function editContactGroup(contactGroup, dispatch) {
    return new Promise((resolve, reject) => {
        request("PUT",  "/recorder/api/contact-groups/" + contactGroup.id, JSON.stringify(toContactGroupAddedEvent(contactGroup)), response => {
            if (hasErrors(response)) {
                reject({ _error: response.errors });
            } else {
                dispatch(updateContactGroup(contactGroup));
                resolve();
            }
        });
    });
}


export function deleteContactGroup(contactGroup) {
    return new Promise((resolve, reject) => {
        request("DELETE",  "/recorder/api/contact-groups/" + contactGroup.id, null, response => {
            if (hasErrors(response)) {
                reject({ _error: response.errors });
            } else {
                resolve();
            }

        });
    });
}





/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/actions/saveContactGroup.js
 **/